import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-bg flex flex-col items-center justify-center px-6 page-enter">
      <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mb-4">
        <XCircle className="text-red-500" size={42} />
      </div>
      <h1 className="font-heading font-bold text-3xl text-ink text-center">Pagamento annullato</h1>
      <p className="text-ink-soft text-center mt-2 max-w-sm">
        Nessun addebito è stato effettuato. Puoi riprovare in qualunque momento.
      </p>
      <button
        data-testid="payment-cancel-back"
        onClick={() => navigate(-1)}
        className="mt-6 inline-flex items-center gap-2 bg-brand hover:bg-brand-hover text-white px-6 py-3 rounded-full font-semibold transition"
      >
        <ArrowLeft size={18} /> Torna indietro
      </button>
    </div>
  );
}
